import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SceneTreeCore = _resolveComponent("SceneTreeCore")!

  return (_openBlock(), _createElementBlock("div", {
    class: "Panel SceneTree full_height_container grid-y",
    onPointermove: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.on_pointer_move && _ctx.on_pointer_move(...args)))
  }, [
    _createVNode(_component_SceneTreeCore, {
      maskOnStart: _ctx.mask,
      showNamesOnly: false,
      onMaskUpdated: _ctx.onMaskUpdated
    }, null, 8 /* PROPS */, ["maskOnStart", "onMaskUpdated"])
  ], 32 /* HYDRATE_EVENTS */))
}